import { PageWrapper } from '../../components/PageWrapper';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HOME, PHONE_PASSWORD_FORGOT } from '../../constants/routes';
import { submitPasswordForLogin, handleForgotPasswordFlow } from '../../utils/phoneNumber';
import { auth } from '../../firebase/firebaseConfig';
import useAxios from '../../axios/useAxios';
import OtpInput from 'react18-input-otp';
import { BeatLoader } from 'react-spinners';
export const PhonePasswordScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const axiosInstance = useAxios();
  const { cartItems } = useSelector((state) => state.cart);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [lockUntil, setLockUntil] = useState(null);
  const [passwordError, setPasswordError] = useState('');
  const { phoneNumber, userExists } = location.state || {};

  useEffect(() => {
    if (!phoneNumber) {
      navigate(HOME);
    }
  }, [phoneNumber, navigate]);

  const handleSubmitPassword = async () => {
    if (password.length !== 6) return;
    setLoading(true);
    const success = await submitPasswordForLogin({
      password,
      confirmPassword: password, // For existing users, we don't need confirmation
      isSignup: !userExists,
      phoneNumber,
      setLoading,
      setPassword,
      auth,
      dispatch,
      axiosInstance,
      cartItems,
      navigate,
      userResult: auth.currentUser,
      setLockUntil,
      setError: setPasswordError,
    });


    if (!success) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (password.length === 6) {
      handleSubmitPassword();
    }
  }, [password]);

  // Handle forgot password
  const handleForgotPassword = async () => {
    if (!phoneNumber) return;

    setLoading(true);

    const result = await handleForgotPasswordFlow({
      phoneNumber,
      auth,
      axiosInstance,
      setLoading,
      recaptchaContainerId: 'forgot-password-recaptcha',
    });

    if (result.success) {
      // Navigate to OTP verification screen
      navigate(PHONE_PASSWORD_FORGOT, {
        state: { phoneNumber: result.phoneNumber, userExists },
      });
    }
    setLoading(false);
  };
  useEffect(() => {
    console.info({ loading });
  }, [loading]);
  return (
    <PageWrapper
      title={userExists ? "🔑 Entre ton mot de passe" : "🔑 Crée ton mot de passe"}
      onGoBack={() => navigate(HOME)}
    >
      <div className="flex flex-col items-center justify-center gap-4">

        {loading ? (
          <BeatLoader color="#183153" size={20} />
        ) : (
          <OtpInput
          value={password}
          onChange={setPassword}
          numInputs={6}
          isInputNum={true}
          shouldAutoFocus={true}
          inputStyle="password-input"
          isInputSecure={true}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          separator={<span className="otp-separator" />}
          containerStyle="otp-container"
        />
        )}
        {passwordError && (
          <p className="text-red-500 text-lg mt-2">{passwordError}</p>
        )}

        {lockUntil && (
          <p className="text-red-500 text-lg mt-2">
            Compte temporairement bloqué
          </p>
        )}

        {userExists && (
          <button
            type="button"
            className="geomanistMedium mt-8 text-2xl p-4 bg-[#E6E6E6] rounded-full w-full"
            disabled={loading}
            onClick={handleForgotPassword}
          >
            {loading ? 'Envoi du code...' : 'J\'ai oublié mon mot de passe'}
          </button>
        )}
      </div>
    </PageWrapper>
  );
};